import Vue from "vue";
import Vuex from "vuex";
import Vueditor from "vueditor";
import Vuelidate from "vuelidate";
import VueMeta from "vue-meta";
import App from "./App.vue";
import router from "./router";
import storeConfig from "./store";
import axios from "axios";
import config from "@/plugins/vueditor";
import moment from "moment";

Vue.config.productionTip = false;
Vue.use(Vuex);

// Devtools displays only first store, so we should overrun vueditor
const store = new Vuex.Store(storeConfig);

Vue.use(Vueditor, config);
Vue.use(Vuelidate);
Vue.use(VueMeta);

moment.locale("ru");

Vue.filter("formatRelTime", timestamp =>
  timestamp ? moment.utc(timestamp * 1000).local().fromNow() : ""
);

Vue.filter("formatAbsTime", timestamp =>
    timestamp ? moment.utc(timestamp * 1000).local().format("MMMM Do YYYY, HH:mm") : ""
);

if (process.env.NODE_ENV === "development") {
  // disable CORS
  axios.defaults.withCredentials = true;
}

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch("getUser").then(() => {
      if (store.getters.isAuth) {
        next();
        return;
      }
      next("/");
    });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
